import { JSX, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { List } from '@chakra-ui/react'
import { Location } from '@leid/api-locations'

import { ButtonOutlined } from 'components/ui/Buttons/Button'

type Props = {
  locations: Location[]
  selectedLocationId: number | undefined
  isDimmed: boolean
  onLocationChange: (selectedLocation: Location | undefined) => void
}

const LocationsList = (props: Props): JSX.Element => {
  const { locations, selectedLocationId, isDimmed, onLocationChange } = props

  const { t } = useTranslation(['locations'])

  const [listSize] = useState(10)
  const [collapsed, setCollapsed] = useState(false)

  const handleChange = (location: Location) => {
    if (selectedLocationId === location.id) {
      return
    }

    onLocationChange(location)
  }

  return (
    <>
      {locations.length !== 0 && (
        <List.Root width="100%" marginBottom={5} marginTop={5} display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
          {locations.map((location, idx) => {
            if (idx < listSize) {
              return (
                <List.Item
                  key={location.id}
                  onClick={() => handleChange(location)}
                  marginRight={5}
                  marginBottom={5}
                  listStyleType="none"
                >
                  <ButtonOutlined
                    key={location.id}
                    isSelected={selectedLocationId && selectedLocationId === location.id ? true : false}
                    isDimmed={isDimmed}
                  >
                    {location.name}
                  </ButtonOutlined>
                </List.Item>
              )
            }

            const result = (
              <List.Item
                key={location.id}
                onClick={() => handleChange(location)}
                hidden={!collapsed}
                marginRight={5}
                marginBottom={5}
                listStyleType="none"
              >
                <ButtonOutlined key={location.id}>{location.name}</ButtonOutlined>
              </List.Item>
            )

            if (idx === locations.length - 1) {
              return (
                <>
                  {result}
                  <List.Item
                    key="divider"
                    onClick={() => setCollapsed(!collapsed)}
                    marginRight={5}
                    marginBottom={5}
                    listStyleType="none"
                  >
                    <ButtonOutlined key="divider" noBorder={true}>
                      {collapsed ? t('less') : t('more')}
                    </ButtonOutlined>
                  </List.Item>
                </>
              )
            }

            return result
          })}
        </List.Root>
      )}
    </>
  )
}

export default LocationsList
